import { render, staticRenderFns } from "./featured_recipe.vue?vue&type=template&id=73122a42&scoped=true&lang=html&"
import script from "./featured_recipe.vue?vue&type=script&lang=js&"
export * from "./featured_recipe.vue?vue&type=script&lang=js&"
import style0 from "./featured_recipe.vue?vue&type=style&index=0&id=73122a42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73122a42",
  null
  
)

export default component.exports